/* eslint-disable react/no-danger */
import React from 'react';

export default function SectionD(props) {
  const { content } = props;
  const randomQuote = content && content.referents_quotes_page ? content.referents_quotes_page[Math.floor(Math.random() * content.referents_quotes_page.length) + 1] : null;

  function shuffle(a) {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 768) {
        let j;
        let x;
        let i;
        for (i = a.length - 1; i > 0; i -= 1) {
          j = Math.floor(Math.random() * (i + 1));
          x = a[i];
          a[i] = a[j];
          a[j] = x;
        }
        return a.slice(0, 2);
      }
      return a;
    }
  }

  if (content) {
    content.referents_items_page = shuffle(content.referents_items_page);
  }

  return (
    <section className="section-d">
      {content &&
        <div className="container">
          <h2 className="section-title text-center" dangerouslySetInnerHTML={{ __html: content.referents_title }} />
          <ul className="referents">
            {content.referents_items_page && Object.keys(content.referents_items_page).map((key) => {
              const item = content.referents_items_page[key];
              return (
                <li key={item.image.source_url}>
                  <a
                    className={item.url ? 'active' : 'disabled'}
                    href={item.url ? item.url : ''}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={item.image.source_url} data-src={item.image.source_url} alt="" className="lazy-load" />
                  </a>
                </li>
              );
            })}
          </ul>

          {randomQuote &&
            <div className="item-quote">
              <div className="quote" dangerouslySetInnerHTML={{ __html: randomQuote.quote }} />
              <div className="author" dangerouslySetInnerHTML={{ __html: randomQuote.author }} />
            </div>}
        </div>}
    </section>
  );
}
